module.exports={"wireguard adapter settings":"Impostazioni dell'adattatore per wireguard",option1:"opzione 1",option2:"opzione 2"};